import {
    CorporationKcfInformationResponse,
    ICorporationKcfInformationResponse,
} from '@kcftech/prometheus-client';
import {
    QueryObserverOptions,
    QueryObserverResult,
    skipToken,
    useQuery,
} from '@tanstack/react-query';
import { dayMs, hourMs } from 'components/date_time/time';
import { sdClient } from 'contexts/SDKClientContext';
import { queryClient } from 'utils/query';

type QueryData = CorporationKcfInformationResponse | undefined;
type QueryError = Partial<Error>;

export const corporationKcfInfoQueryKey = 'corporation-kcf-info';

export function useCorporationKcfInfo(
    id: string | undefined,
    options?: QueryObserverOptions<QueryData, QueryError>,
): QueryObserverResult<ICorporationKcfInformationResponse | undefined, Partial<Error>> {
    return useQuery<QueryData, QueryError>({
        queryKey: [corporationKcfInfoQueryKey, id],

        queryFn: id
            ? async () => sdClient.getCorporationKcfInformation({ corporationId: id })
            : skipToken,

        gcTime: 7 * dayMs,
        staleTime: hourMs,
        ...options,
    });
}

export function invalidateCorporationKcfinfo(id: string) {
    queryClient.invalidateQueries({
        queryKey: [corporationKcfInfoQueryKey, id],
    });
}
